export const colors = {
  bgInputError: '#e0d4d4',
  blueInput: '#2196F3',
  darkenGray: '#cccccc',
  darkenGraySecondary: '#D9D9D9',
  darkenGraySecondaryLight: '#E8EDED',
  disabled: '#747474',
  error: '#C32F2F',
  grayDisabled: '#F5F5F5',
  grayFoco: '#6D6D6D',
  lightGray: '#f0f0f0',
  orangeCarrot: '#D66514',
  orangeInput: '#FF9800',
  orangeWithOpacity: '#f6eee9',
  paleSilver: '#BBB5B5',
  primary: '#d66514',
  primaryBlue: '#3D4A5D',
  primaryLight: '#e9c7af',
  redInput: '#F44336',
  skyBlue: '#B9C3D1',
  steelBlueGray: '#505C6E',
  success: '#429254',
  text1: '#1D1C1C',
  text2: '#4d4d4d',
  warning: '#E78B49',
  yellowAlert: '#FFA629',
};

export const boxShadow = {
  100: '0px 4px 8px -4px rgba(23, 23, 23, 0.25)',
  200: '0px 8px 12px -4px rgba(23, 23, 23, 0.25)',
  300: '0px 12px 16px -4px rgba(23, 23, 23, 0.25)',
  down: '0px -1px 0px 0px #E8EDED inset',
  left: '1px 0px 0px 0px #E8EDED inset',
  right: '-1px 0px 0px 0px #E8EDED inset',
  up: '0px 1px 0px 0px #E8EDED inset',
};

export const fonts = {
  InterBold: 'Inter-Bold',
  InterLight: 'Inter-Light',
  InterMedium: 'Inter-Medium',
  InterRegular: 'Inter-Regular',
  InterSemiBold: 'Inter-SemiBold',
};
